(() => {
  'use strict';
  const normalise = value => String(value ?? '').trim().toUpperCase();
  function cartTokens(cart) {
    return new Set((cart?.appliedPromotions || []).flatMap(promotion => [promotion.promotionToken, promotion.triggerToken]).filter(Boolean).map(normalise));
  }
  function linkToken(href, base, inBanner = false) {
    let url;
    try { url = new URL(href, base); } catch { return ''; }
    const origin = new URL(base).origin;
    if (url.origin !== origin) return '';
    const explicit = url.hash.match(/^#discount(?:[-_/]?)([a-z0-9]+)$/i);
    if (explicit) return normalise(explicit[1]);
    if (!inBanner) return '';
    const token = url.searchParams.get('token');
    if (token && /^[a-z0-9]+$/i.test(token)) return normalise(token);
    const path = url.pathname.match(/\/discount[-/]([a-z0-9]+)\/?$/i);
    if (path) return normalise(path[1]);
    return normalise(url.hash.match(/^#([a-z0-9]{4,})$/i)?.[1]);
  }
  function eligible(records, tokens) {
    return records.filter(record => record.customerMatch || tokens.has(normalise(record.token)));
  }
  window.AllureDiscountDetails = { cartTokens, linkToken, eligible };
  const dialog = document.querySelector('#ae-disclaimer-dialog');
  const prototype = document.querySelector('#ae-disclaimer-button');
  if (!dialog || !prototype) return;
  const records = [...document.querySelectorAll('[data-ae-disclaimer-record]')].map(template => ({
    token: normalise(template.dataset.token),
    name: template.dataset.name,
    customerMatch: template.dataset.customerMatch === 'true',
    template
  }));
  const byToken = new Map(records.map(record => [record.token, record]));
  let tokens = cartTokens(window.AE_DN_EVENT), opener = null;
  function render() {
    const visible = eligible(records, tokens);
    document.querySelectorAll('[data-ae-disclaimer-list]').forEach(list => {
      const signature = visible.map(record => record.token).join('|');
      list.hidden = visible.length === 0;
      if (list.dataset.rendered === signature) return;
      const focusedToken = list.contains(document.activeElement) ? document.activeElement.dataset.aeDisclaimerOpen : null;
      list.replaceChildren(...visible.map(record => {
        const button = prototype.content.firstElementChild.cloneNode(true);
        button.dataset.aeDisclaimerOpen = record.token;
        button.querySelector('[data-ae-disclaimer-name]').textContent = record.name;
        return button;
      }));
      list.dataset.rendered = signature;
      if (focusedToken) [...list.querySelectorAll('button')].find(button => button.dataset.aeDisclaimerOpen === focusedToken)?.focus({ preventScroll: true });
    });
  }
  function open(token, trigger = document.activeElement) {
    const record = byToken.get(normalise(token));
    if (!record) return false;
    if (!dialog.open) opener = trigger;
    dialog.querySelector('#ae-disclaimer-title').textContent = record.name;
    dialog.querySelector('[data-ae-disclaimer-copy]').replaceChildren(record.template.content.cloneNode(true));
    if (!dialog.open) dialog.showModal();
    dialog.scrollTop = 0;
    document.body.classList.add('ae-disclaimer-open');
    dialog.querySelector('[data-ae-disclaimer-close]').focus({ preventScroll: true });
    return true;
  }
  function close() { if (dialog.open) dialog.close(); }
  dialog.addEventListener('close', () => {
    document.body.classList.remove('ae-disclaimer-open');
    if (opener?.isConnected && opener.getClientRects().length) opener.focus({ preventScroll: true });
    else if (window.AE?.panel) document.querySelector('#ae-drawer [data-ae-close]')?.focus({ preventScroll: true });
    opener = null;
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  document.addEventListener('keydown', event => {
    if (dialog.open && event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close(); }
  }, true);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-ae-disclaimer-open]');
    if (trigger) { event.preventDefault(); event.stopPropagation(); open(trigger.dataset.aeDisclaimerOpen, trigger); return; }
    if (event.target.closest('[data-ae-disclaimer-close]')) { close(); return; }
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target === '_blank') return;
    const inBanner = Boolean(link.closest('#limoniapps-discountninja-stickybar-wrapper,la-dn-announcement-bar'));
    const token = normalise(link.dataset.discountToken || (inBanner ? link.dataset.token : '')) || linkToken(link.getAttribute('href'), location.href, inBanner);
    if (token && byToken.has(token)) { event.preventDefault(); event.stopPropagation(); open(token, link); }
  }, true);
  document.addEventListener('la:dn:cart:updated', event => {
    const cart = event.detail?.data?.[0];
    if (!cart || !Array.isArray(cart.appliedPromotions)) return;
    tokens = cartTokens(cart); render();
  });
  document.addEventListener('ae:cart:rendered', render);
  document.addEventListener('shopify:section:load', render);
  window.showStickyBarDiscountLightbox = token => open(token);
  window.closeStickyBarDiscountLightbox = close;
  render();
})();
